import { createFileRoute, redirect } from '@tanstack/react-router';
import { APP_ID } from '@/features/app-integration/constant';
import { orpc } from '@/lib/api/orpc';
import { remainingTimeToday } from '@/lib/query';
import { getSoftware } from '../-query/api';
import { softwareKey } from '../-query/key';

// `/software/$id/settings` 直下に着いた際の自動遷移先を、サイドメニュー
// (`route.lazy.tsx`) の出し分けと一致させる:
// - 連携なし Software (`appIntegrationId === null`): role/status のみ表示 → `/role`
// - 連携あり & custom SaaS (`appId === CUSTOM_APP`): role/status + 連携セクション → `/role`
// - 連携あり & 非 custom SaaS: 連携セクションのみ → `/integration`
export const Route = createFileRoute('/_staff/software/$id/_$id/settings/')({
  beforeLoad: async ({
    params,
    context
  }) => {
    const software = await context.queryClient.ensureQueryData({
      queryKey: softwareKey.contract(params.id),
      queryFn: () => getSoftware(params.id),
      staleTime: remainingTimeToday()
    });
    if (software.appIntegrationId === null) {
      throw redirect({
        to: '/software/$id/settings/role',
        params
      });
    }
    const contract = await context.queryClient.ensureQueryData({
      ...orpc.software.overviewAppContract.queryOptions({
        input: {
          softwareId: software.id
        }
      }),
      staleTime: remainingTimeToday()
    });
    throw redirect({
      to: contract.app.appId === APP_ID.CUSTOM_APP ? '/software/$id/settings/role' : '/software/$id/settings/integration',
      params
    });
  }
});